import { Country } from '@/types';

export const JURISDICTIONS: Country[] = [
  { name: 'Åland Islands', alpha2code: 'AX', alpha3code: 'ALA' },
  { name: 'Zimbabwe', alpha2code: 'ZW', alpha3code: 'ZWE' },
  { name: 'Zambia', alpha2code: 'ZM', alpha3code: 'ZMB' },
  { name: 'Yemen', alpha2code: 'YE', alpha3code: 'YEM' },
  { name: 'Western Sahara', alpha2code: 'EH', alpha3code: 'ESH' },
  { name: 'Wallis and Futuna', alpha2code: 'WF', alpha3code: 'WLF' },
  { name: 'Virgin Islands (U.S.)', alpha2code: 'VI', alpha3code: 'VIR' },
  { name: 'Virgin Islands (British)', alpha2code: 'VG', alpha3code: 'VGB' },
  { name: 'Vietnam', alpha2code: 'VN', alpha3code: 'VNM' },
  { name: 'Venezuela', alpha2code: 'VE', alpha3code: 'VEN' },
  { name: 'Vanuatu', alpha2code: 'VU', alpha3code: 'VUT' },
  { name: 'Uzbekistan', alpha2code: 'UZ', alpha3code: 'UZB' },
  { name: 'Uruguay', alpha2code: 'UY', alpha3code: 'URY' },
  { name: 'United States', alpha2code: 'US', alpha3code: 'USA' },
  { name: 'United States Minor Outlying Islands', alpha2code: 'UM', alpha3code: 'UMI' },
  { name: 'United Kingdom', alpha2code: 'GB', alpha3code: 'GBR' },
  { name: 'United Arab Emirates', alpha2code: 'AE', alpha3code: 'ARE' },
  { name: 'Ukraine', alpha2code: 'UA', alpha3code: 'UKR' },
  { name: 'Uganda', alpha2code: 'UG', alpha3code: 'UGA' },
  { name: 'Tuvalu', alpha2code: 'TV', alpha3code: 'TUV' },
  { name: 'Turks and Caicos Islands', alpha2code: 'TC', alpha3code: 'TCA' },
  { name: 'Turkmenistan', alpha2code: 'TM', alpha3code: 'TKM' },
  { name: 'Turkey', alpha2code: 'TR', alpha3code: 'TUR' },
  { name: 'Tunisia', alpha2code: 'TN', alpha3code: 'TUN' },
  { name: 'Trinidad and Tobago', alpha2code: 'TT', alpha3code: 'TTO' },
  { name: 'Tonga', alpha2code: 'TO', alpha3code: 'TON' },
  { name: 'Tokelau', alpha2code: 'TK', alpha3code: 'TKL' },
  { name: 'Togo', alpha2code: 'TG', alpha3code: 'TGO' },
  { name: 'Timor-Leste', alpha2code: 'TL', alpha3code: 'TLS' },
  { name: 'Thailand', alpha2code: 'TH', alpha3code: 'THA' },
  { name: 'Tanzania', alpha2code: 'TZ', alpha3code: 'TZA' },
  { name: 'Tajikistan', alpha2code: 'TJ', alpha3code: 'TJK' },
  { name: 'Taiwan', alpha2code: 'TW', alpha3code: 'TWN' },
  { name: 'Syrian Arab Republic', alpha2code: 'SY', alpha3code: 'SYR' },
  { name: 'Switzerland', alpha2code: 'CH', alpha3code: 'CHE' },
  { name: 'Sweden', alpha2code: 'SE', alpha3code: 'SWE' },
  { name: 'Svalbard and Jan Mayen', alpha2code: 'SJ', alpha3code: 'SJM' },
  { name: 'Suriname', alpha2code: 'SR', alpha3code: 'SUR' },
  { name: 'Sudan', alpha2code: 'SD', alpha3code: 'SDN' },
  { name: 'Sri Lanka', alpha2code: 'LK', alpha3code: 'LKA' },
  { name: 'Spain', alpha2code: 'ES', alpha3code: 'ESP' },
  { name: 'South Sudan', alpha2code: 'SS', alpha3code: 'SSD' },
  {
    name: 'South Georgia and the South Sandwich Islands',
    alpha2code: 'GS',
    alpha3code: 'SGS',
  },
  { name: 'South Africa', alpha2code: 'ZA', alpha3code: 'ZAF' },
  { name: 'Somalia', alpha2code: 'SO', alpha3code: 'SOM' },
  { name: 'Solomon Islands', alpha2code: 'SB', alpha3code: 'SLB' },
  { name: 'Slovenia', alpha2code: 'SI', alpha3code: 'SVN' },
  { name: 'Slovakia', alpha2code: 'SK', alpha3code: 'SVK' },
  { name: 'Sint Maarten (Dutch part)', alpha2code: 'SX', alpha3code: 'SXM' },
  { name: 'Singapore', alpha2code: 'SG', alpha3code: 'SGP' },
  { name: 'Sierra Leone', alpha2code: 'SL', alpha3code: 'SLE' },
  { name: 'Seychelles', alpha2code: 'SC', alpha3code: 'SYC' },
  { name: 'Serbia', alpha2code: 'RS', alpha3code: 'SRB' },
  { name: 'Senegal', alpha2code: 'SN', alpha3code: 'SEN' },
  { name: 'Saudi Arabia', alpha2code: 'SA', alpha3code: 'SAU' },
  { name: 'São Tomé and Príncipe', alpha2code: 'ST', alpha3code: 'STP' },
  { name: 'San Marino', alpha2code: 'SM', alpha3code: 'SMR' },
  { name: 'Samoa', alpha2code: 'WS', alpha3code: 'WSM' },
  { name: 'Saint Vincent and the Grenadines', alpha2code: 'VC', alpha3code: 'VCT' },
  { name: 'Saint Pierre and Miquelon', alpha2code: 'PM', alpha3code: 'SPM' },
  { name: 'Saint Martin', alpha2code: 'MF', alpha3code: 'MAF' },
  { name: 'Saint Lucia', alpha2code: 'LC', alpha3code: 'LCA' },
  { name: 'Saint Kitts and Nevis', alpha2code: 'KN', alpha3code: 'KNA' },
  { name: 'Saint Helena', alpha2code: 'SH', alpha3code: 'SHN' },
  { name: 'Saint Barthélemy', alpha2code: 'BL', alpha3code: 'BLM' },
  { name: 'Réunion', alpha2code: 'RE', alpha3code: 'REU' },
  { name: 'Rwanda', alpha2code: 'RW', alpha3code: 'RWA' },
  { name: 'Russia', alpha2code: 'RU', alpha3code: 'RUS' },
  { name: 'Romania', alpha2code: 'RO', alpha3code: 'ROU' },
  { name: 'Macedonia', alpha2code: 'MK', alpha3code: 'MKD' },
  { name: 'Qatar', alpha2code: 'QA', alpha3code: 'QAT' },
  { name: 'Puerto Rico', alpha2code: 'PR', alpha3code: 'PRI' },
  { name: 'Portugal', alpha2code: 'PT', alpha3code: 'PRT' },
  { name: 'Poland', alpha2code: 'PL', alpha3code: 'POL' },
  { name: 'Pitcairn Islands', alpha2code: 'PN', alpha3code: 'PCN' },
  { name: 'Philippines', alpha2code: 'PH', alpha3code: 'PHL' },
  { name: 'Peru', alpha2code: 'PE', alpha3code: 'PER' },
  { name: 'Paraguay', alpha2code: 'PY', alpha3code: 'PRY' },
  { name: 'Papua New Guinea', alpha2code: 'PG', alpha3code: 'PNG' },
  { name: 'Panama', alpha2code: 'PA', alpha3code: 'PAN' },
  { name: 'Palestinian Territories', alpha2code: 'PS', alpha3code: 'PSE' },
  { name: 'Palau', alpha2code: 'PW', alpha3code: 'PLW' },
  { name: 'Pakistan', alpha2code: 'PK', alpha3code: 'PAK' },
  { name: 'Oman', alpha2code: 'OM', alpha3code: 'OMN' },
  { name: 'Norway', alpha2code: 'NO', alpha3code: 'NOR' },
  { name: 'Northern Mariana Islands', alpha2code: 'MP', alpha3code: 'MNP' },
  { name: 'Norfolk Island', alpha2code: 'NF', alpha3code: 'NFK' },
  { name: 'Niue', alpha2code: 'NU', alpha3code: 'NIU' },
  { name: 'Nigeria', alpha2code: 'NG', alpha3code: 'NGA' },
  { name: 'Niger', alpha2code: 'NE', alpha3code: 'NER' },
  { name: 'Nicaragua', alpha2code: 'NI', alpha3code: 'NIC' },
  { name: 'New Zealand', alpha2code: 'NZ', alpha3code: 'NZL' },
  { name: 'New Caledonia', alpha2code: 'NC', alpha3code: 'NCL' },
  { name: 'Netherlands', alpha2code: 'NL', alpha3code: 'NLD' },
  { name: 'Nepal', alpha2code: 'NP', alpha3code: 'NPL' },
  { name: 'Nauru', alpha2code: 'NR', alpha3code: 'NRU' },
  { name: 'Namibia', alpha2code: 'NA', alpha3code: 'NAM' },
  { name: 'Myanmar', alpha2code: 'MM', alpha3code: 'MMR' },
  { name: 'Mozambique', alpha2code: 'MZ', alpha3code: 'MOZ' },
  { name: 'Morocco', alpha2code: 'MA', alpha3code: 'MAR' },
  { name: 'Montserrat', alpha2code: 'MS', alpha3code: 'MSR' },
  { name: 'Montenegro', alpha2code: 'ME', alpha3code: 'MNE' },
  { name: 'Mongolia', alpha2code: 'MN', alpha3code: 'MNG' },
  { name: 'Monaco', alpha2code: 'MC', alpha3code: 'MCO' },
  { name: 'Moldova', alpha2code: 'MD', alpha3code: 'MDA' },
  { name: 'Micronesia', alpha2code: 'FM', alpha3code: 'FSM' },
  { name: 'Mexico', alpha2code: 'MX', alpha3code: 'MEX' },
  { name: 'Mayotte', alpha2code: 'YT', alpha3code: 'MYT' },
  { name: 'Mauritius', alpha2code: 'MU', alpha3code: 'MUS' },
  { name: 'Mauritania', alpha2code: 'MR', alpha3code: 'MRT' },
  { name: 'Martinique', alpha2code: 'MQ', alpha3code: 'MTQ' },
  { name: 'Marshall Islands', alpha2code: 'MH', alpha3code: 'MHL' },
  { name: 'Malta', alpha2code: 'MT', alpha3code: 'MLT' },
  { name: 'Mali', alpha2code: 'ML', alpha3code: 'MLI' },
  { name: 'Maldives', alpha2code: 'MV', alpha3code: 'MDV' },
  { name: 'Malaysia', alpha2code: 'MY', alpha3code: 'MYS' },
  { name: 'Malawi', alpha2code: 'MW', alpha3code: 'MWI' },
  { name: 'Madagascar', alpha2code: 'MG', alpha3code: 'MDG' },
  { name: 'Macau', alpha2code: 'MO', alpha3code: 'MAC' },
  { name: 'Luxembourg', alpha2code: 'LU', alpha3code: 'LUX' },
  { name: 'Lithuania', alpha2code: 'LT', alpha3code: 'LTU' },
  { name: 'Liechtenstein', alpha2code: 'LI', alpha3code: 'LIE' },
  { name: 'Libya', alpha2code: 'LY', alpha3code: 'LBY' },
  { name: 'Liberia', alpha2code: 'LR', alpha3code: 'LBR' },
  { name: 'Lesotho', alpha2code: 'LS', alpha3code: 'LSO' },
  { name: 'Lebanon', alpha2code: 'LB', alpha3code: 'LBN' },
  { name: 'Latvia', alpha2code: 'LV', alpha3code: 'LVA' },
  { name: 'Laos', alpha2code: 'LA', alpha3code: 'LAO' },
  { name: 'Kyrgyzstan', alpha2code: 'KG', alpha3code: 'KGZ' },
  { name: 'Kuwait', alpha2code: 'KW', alpha3code: 'KWT' },
  { name: 'South Korea', alpha2code: 'KR', alpha3code: 'KOR' },
  { name: 'North Korea', alpha2code: 'KP', alpha3code: 'PRK' },
  { name: 'Kiribati', alpha2code: 'KI', alpha3code: 'KIR' },
  { name: 'Kenya', alpha2code: 'KE', alpha3code: 'KEN' },
  { name: 'Kazakhstan', alpha2code: 'KZ', alpha3code: 'KAZ' },
  { name: 'Jordan', alpha2code: 'JO', alpha3code: 'JOR' },
  { name: 'Jersey', alpha2code: 'JE', alpha3code: 'JEY' },
  { name: 'Japan', alpha2code: 'JP', alpha3code: 'JPN' },
  { name: 'Jamaica', alpha2code: 'JM', alpha3code: 'JAM' },
  { name: 'Italy', alpha2code: 'IT', alpha3code: 'ITA' },
  { name: 'Israel', alpha2code: 'IL', alpha3code: 'ISR' },
  { name: 'Isle of Man', alpha2code: 'IM', alpha3code: 'IMN' },
  { name: 'Ireland', alpha2code: 'IE', alpha3code: 'IRL' },
  { name: 'Iraq', alpha2code: 'IQ', alpha3code: 'IRQ' },
  { name: 'Iran', alpha2code: 'IR', alpha3code: 'IRN' },
  { name: 'Indonesia', alpha2code: 'ID', alpha3code: 'IDN' },
  { name: 'India', alpha2code: 'IN', alpha3code: 'IND' },
  { name: 'Iceland', alpha2code: 'IS', alpha3code: 'ISL' },
  { name: 'Hungary', alpha2code: 'HU', alpha3code: 'HUN' },
  { name: 'Hong Kong', alpha2code: 'HK', alpha3code: 'HKG' },
  { name: 'Honduras', alpha2code: 'HN', alpha3code: 'HND' },
  { name: 'Holy See', alpha2code: 'VA', alpha3code: 'VAT' },
  { name: 'Heard Island and McDonald Islands', alpha2code: 'HM', alpha3code: 'HMD' },
  { name: 'Haiti', alpha2code: 'HT', alpha3code: 'HTI' },
  { name: 'Guyana', alpha2code: 'GY', alpha3code: 'GUY' },
  { name: 'Guinea-Bissau', alpha2code: 'GW', alpha3code: 'GNB' },
  { name: 'Guinea', alpha2code: 'GN', alpha3code: 'GIN' },
  { name: 'Guernsey', alpha2code: 'GG', alpha3code: 'GGY' },
  { name: 'Guatemala', alpha2code: 'GT', alpha3code: 'GTM' },
  { name: 'Guam', alpha2code: 'GU', alpha3code: 'GUM' },
  { name: 'Guadeloupe', alpha2code: 'GP', alpha3code: 'GLP' },
  { name: 'Grenada', alpha2code: 'GD', alpha3code: 'GRD' },
  { name: 'Greenland', alpha2code: 'GL', alpha3code: 'GRL' },
  { name: 'Greece', alpha2code: 'GR', alpha3code: 'GRC' },
  { name: 'Gibraltar', alpha2code: 'GI', alpha3code: 'GIB' },
  { name: 'Ghana', alpha2code: 'GH', alpha3code: 'GHA' },
  { name: 'Germany', alpha2code: 'DE', alpha3code: 'DEU' },
  { name: 'Georgia', alpha2code: 'GE', alpha3code: 'GEO' },
  { name: 'Gambia', alpha2code: 'GM', alpha3code: 'GMB' },
  { name: 'Gabon', alpha2code: 'GA', alpha3code: 'GAB' },
  { name: 'French Southern Territories', alpha2code: 'TF', alpha3code: 'ATF' },
  { name: 'French Polynesia', alpha2code: 'PF', alpha3code: 'PYF' },
  { name: 'French Guiana', alpha2code: 'GF', alpha3code: 'GUF' },
  { name: 'France', alpha2code: 'FR', alpha3code: 'FRA' },
  { name: 'Finland', alpha2code: 'FI', alpha3code: 'FIN' },
  { name: 'Fiji', alpha2code: 'FJ', alpha3code: 'FJI' },
  { name: 'Faroe Islands', alpha2code: 'FO', alpha3code: 'FRO' },
  { name: 'Falkland Islands', alpha2code: 'FK', alpha3code: 'FLK' },
  { name: 'Ethiopia', alpha2code: 'ET', alpha3code: 'ETH' },
  { name: 'Eswatini', alpha2code: 'SZ', alpha3code: 'SWZ' },
  { name: 'Estonia', alpha2code: 'EE', alpha3code: 'EST' },
  { name: 'Eritrea', alpha2code: 'ER', alpha3code: 'ERI' },
  { name: 'Equatorial Guinea', alpha2code: 'GQ', alpha3code: 'GNQ' },
  { name: 'El Salvador', alpha2code: 'SV', alpha3code: 'SLV' },
  { name: 'Egypt', alpha2code: 'EG', alpha3code: 'EGY' },
  { name: 'Ecuador', alpha2code: 'EC', alpha3code: 'ECU' },
  { name: 'Dominican Republic', alpha2code: 'DO', alpha3code: 'DOM' },
  { name: 'Dominica', alpha2code: 'DM', alpha3code: 'DMA' },
  { name: 'Djibouti', alpha2code: 'DJ', alpha3code: 'DJI' },
  { name: 'Denmark', alpha2code: 'DK', alpha3code: 'DNK' },
  { name: "Côte d'Ivoire", alpha2code: 'CI', alpha3code: 'CIV' },
  { name: 'Czech Republic', alpha2code: 'CZ', alpha3code: 'CZE' },
  { name: 'Cyprus', alpha2code: 'CY', alpha3code: 'CYP' },
  { name: 'Curaçao', alpha2code: 'CW', alpha3code: 'CUW' },
  { name: 'Cuba', alpha2code: 'CU', alpha3code: 'CUB' },
  { name: 'Croatia', alpha2code: 'HR', alpha3code: 'HRV' },
  { name: 'Costa Rica', alpha2code: 'CR', alpha3code: 'CRI' },
  { name: 'Cook Islands', alpha2code: 'CK', alpha3code: 'COK' },
  { name: 'Congo - Brazzaville', alpha2code: 'CG', alpha3code: 'COG' },
  { name: 'Congo - Kinshasa', alpha2code: 'CD', alpha3code: 'COD' },
  { name: 'Comoros', alpha2code: 'KM', alpha3code: 'COM' },
  { name: 'Colombia', alpha2code: 'CO', alpha3code: 'COL' },
  { name: 'Cocos [Keeling] Islands', alpha2code: 'CC', alpha3code: 'CCK' },
  { name: 'Christmas Island', alpha2code: 'CX', alpha3code: 'CXR' },
  { name: 'China', alpha2code: 'CN', alpha3code: 'CHN' },
  { name: 'Chile', alpha2code: 'CL', alpha3code: 'CHL' },
  { name: 'Chad', alpha2code: 'TD', alpha3code: 'TCD' },
  { name: 'Central African Republic', alpha2code: 'CF', alpha3code: 'CAF' },
  { name: 'Cayman Islands', alpha2code: 'KY', alpha3code: 'CYM' },
  { name: 'Canada', alpha2code: 'CA', alpha3code: 'CAN' },
  { name: 'Cameroon', alpha2code: 'CM', alpha3code: 'CMR' },
  { name: 'Cambodia', alpha2code: 'KH', alpha3code: 'KHM' },
  { name: 'Cape Verde', alpha2code: 'CV', alpha3code: 'CPV' },
  { name: 'Burundi', alpha2code: 'BI', alpha3code: 'BDI' },
  { name: 'Burkina Faso', alpha2code: 'BF', alpha3code: 'BFA' },
  { name: 'Bulgaria', alpha2code: 'BG', alpha3code: 'BGR' },
  { name: 'Brunei', alpha2code: 'BN', alpha3code: 'BRN' },
  { name: 'British Indian Ocean Territory', alpha2code: 'IO', alpha3code: 'IOT' },
  { name: 'Brazil', alpha2code: 'BR', alpha3code: 'BRA' },
  { name: 'Bouvet Island', alpha2code: 'BV', alpha3code: 'BVT' },
  { name: 'Botswana', alpha2code: 'BW', alpha3code: 'BWA' },
  { name: 'Bosnia and Herzegovina', alpha2code: 'BA', alpha3code: 'BIH' },
  { name: 'Bonaire, Sint Eustatius and Saba', alpha2code: 'BQ', alpha3code: 'BES' },
  { name: 'Bolivia', alpha2code: 'BO', alpha3code: 'BOL' },
  { name: 'Bhutan', alpha2code: 'BT', alpha3code: 'BTN' },
  { name: 'Bermuda', alpha2code: 'BM', alpha3code: 'BMU' },
  { name: 'Benin', alpha2code: 'BJ', alpha3code: 'BEN' },
  { name: 'Belize', alpha2code: 'BZ', alpha3code: 'BLZ' },
  { name: 'Belgium', alpha2code: 'BE', alpha3code: 'BEL' },
  { name: 'Belarus', alpha2code: 'BY', alpha3code: 'BLR' },
  { name: 'Barbados', alpha2code: 'BB', alpha3code: 'BRB' },
  { name: 'Bangladesh', alpha2code: 'BD', alpha3code: 'BGD' },
  { name: 'Bahrain', alpha2code: 'BH', alpha3code: 'BHR' },
  { name: 'Bahamas', alpha2code: 'BS', alpha3code: 'BHS' },
  { name: 'Azerbaijan', alpha2code: 'AZ', alpha3code: 'AZE' },
  { name: 'Austria', alpha2code: 'AT', alpha3code: 'AUT' },
  { name: 'Australia', alpha2code: 'AU', alpha3code: 'AUS' },
  { name: 'Aruba', alpha2code: 'AW', alpha3code: 'ABW' },
  { name: 'Armenia', alpha2code: 'AM', alpha3code: 'ARM' },
  { name: 'Argentina', alpha2code: 'AR', alpha3code: 'ARG' },
  { name: 'Antigua and Barbuda', alpha2code: 'AG', alpha3code: 'ATG' },
  { name: 'Antarctica', alpha2code: 'AQ', alpha3code: 'ATA' },
  { name: 'Anguilla', alpha2code: 'AI', alpha3code: 'AIA' },
  { name: 'Angola', alpha2code: 'AO', alpha3code: 'AGO' },
  { name: 'Andorra', alpha2code: 'AD', alpha3code: 'AND' },
  { name: 'American Samoa', alpha2code: 'AS', alpha3code: 'ASM' },
  { name: 'Algeria', alpha2code: 'DZ', alpha3code: 'DZA' },
  { name: 'Albania', alpha2code: 'AL', alpha3code: 'ALB' },
  { name: 'Afghanistan', alpha2code: 'AF', alpha3code: 'AFG' },
];
